import React from 'react'
import styles from './TileSkeleton.module.css'

export default function TileSkeleton({ type = 'table' }) {
  return (
    <div className={`${styles.skeletonTile} ${type === 'room' ? styles.roomType : styles.tableType}`}>
      {type === 'table' ? (
        // Table Tile Structure
        <>
          {/* Top Row */}
          <div className={styles.topRow}>
            <div className={styles.skeletonPotAmount}>
              <div className={styles.skeletonIcon}></div>
              <div className={styles.skeletonText}></div>
            </div>
            <div className={styles.skeletonPlayersCount}>
              <div className={styles.skeletonIcon}></div>
              <div className={styles.skeletonText}></div>
            </div>
            <div className={styles.skeletonBlindsSection}>
              <div className={styles.skeletonText}></div>
            </div>
          </div>
          
          {/* Bottom Row (optional) */}
          <div className={styles.bottomRow}>
            <div className={styles.skeletonVariantIcons}>
              <div className={styles.skeletonVariantIcon}></div>
              <div className={styles.skeletonVariantIcon}></div>
            </div>
            <div className={styles.skeletonTableStatus}>
              <div className={styles.skeletonDot}></div>
              <div className={styles.skeletonText}></div>
            </div>
          </div>
        </>
      ) : (
        // Room Tile Structure
        <>
          {/* Header */}
          <div className={styles.header}>
            <div className={styles.skeletonNameContainer}>
              <div className={styles.skeletonText}></div>
              <div className={styles.skeletonIcon}></div>
            </div>
            <div className={styles.skeletonFavoriteContainer}>
              <div className={styles.skeletonIcon}></div>
            </div>
          </div>
          
          {/* Details */}
          <div className={styles.details}>
            <div className={`${styles.skeletonInfoItem} ${styles.alignStart}`}>
              <div className={styles.skeletonLabel}></div>
              <div className={styles.skeletonValue}>
                <div className={styles.skeletonIcon}></div>
                <div className={styles.skeletonText}></div>
              </div>
            </div>
            <div className={`${styles.skeletonInfoItem} ${styles.alignCenter}`}>
              <div className={styles.skeletonLabel}></div>
              <div className={styles.skeletonValue}>
                <div className={styles.skeletonIcon}></div>
                <div className={styles.skeletonText}></div>
              </div>
            </div>
            <div className={`${styles.skeletonInfoItem} ${styles.alignEnd}`}>
              <div className={styles.skeletonLabel}></div>
              <div className={styles.skeletonBuyInValue}>
                <div className={styles.skeletonText}></div>
                <div className={styles.skeletonText}></div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
